export class PrefixTrie {
  private root = new Map<string, any>();
  private _size = 0;

  get size(): number {
    return this._size;
  }

  insert(prefix: string) {
    let node = this.root;
    let isNew = false;
    for (const char of prefix) {
      if (!node.has(char)) {
        node.set(char, new Map());
        if (!isNew) isNew = true;
      }
      node = node.get(char);
    }
    if (!node.has('$end')) {
      node.set('$end', prefix);
      if (!isNew) this._size++;
    }
  }

  findMatchingPrefixes(str: string): string[] {
    const matches: string[] = [];
    let node = this.root;

    for (let i = 0; i < str.length; i++) {
      const char = str[i];
      if (!node.has(char)) break;

      node = node.get(char);
      if (node.has('$end')) {
        matches.push(node.get('$end'));
      }
    }

    // Sort by length (longest first) to maintain priority
    return matches.sort((a, b) => b.length - a.length);
  }

  remove(prefix: string) {
    const removeHelper = (node: Map<string, any>, str: string, index: number): boolean => {
      if (index === str.length) {
        if (node.has('$end')) {
          node.delete('$end');
          this._size--;
          return node.size === 0;
        }
        return false;
      }

      const char = str[index];
      const childNode = node.get(char);

      if (!childNode) return false;

      const shouldDeleteChild = removeHelper(childNode, str, index + 1);

      if (shouldDeleteChild) {
        node.delete(char);
        return node.size === 0 && !node.has('$end');
      }

      return false;
    };

    removeHelper(this.root, prefix, 0);
  }

  clear() {
    this.root.clear();
    this._size = 0;
  }
}